import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import {
	BetBuilderPicksPopupBody,
	BetBuilderPicksPopupFooter,
	BetBuilderPicksPopupHeader,
} from "./components/BetBuilderPopup";
import { analyticsTracker } from "@utils/analytics";
import { useFixBody } from "@state/hooks/shared";

export default observer(function BetBuilderPicksPopup() {
	const popupElement = useRef<null | HTMLDivElement>(null);
	const location = useLocation();

	const rootStore = useRootAppStore();

	useFixBody(
		true,
		rootStore.quickPlayStore.betBuilderPicksStore.isPopupDisplayed
	);

	if (
		!location.pathname.includes("home") &&
		!location.pathname.includes("bet-builder-picks")
	) {
		rootStore.quickPlayStore.betBuilderPicksStore.deactivatePopup();
	}

	useEffect(() => {
		popupElement.current?.scrollTo({ top: 0 });
		analyticsTracker.trackModalInteraction("bb-picks");
	}, [rootStore.quickPlayStore.betBuilderPicksStore.selectedBetSlip]);

	if (!rootStore.quickPlayStore.betBuilderPicksStore.selectedBetSlip) {
		return null;
	}

	return (
		<div className="popup popup--qp popup--bbp">
			<div className="popup__card popup--qp__card popup--bbp__card">
				<BetBuilderPicksPopupHeader
					slipNumber={
						rootStore.quickPlayStore.betBuilderPicksStore.slipIndex
					}
					slip={
						rootStore.quickPlayStore.betBuilderPicksStore
							.selectedBetSlip
					}
					isLive={
						rootStore.quickPlayStore.betBuilderPicksStore
							.selectedBetSlip.isLive
					}
					cb={
						rootStore.quickPlayStore.betBuilderPicksStore
							.deactivatePopup
					}
				/>
				<div
					ref={popupElement}
					className="popup__body popup--qp__body popup--bbp__body"
				>
					<BetBuilderPicksPopupBody
						key={
							rootStore.quickPlayStore.betBuilderPicksStore
								.selectedBetSlip.id
						}
						BBPick={
							rootStore.quickPlayStore.betBuilderPicksStore
								.selectedBetSlip
						}
					/>
				</div>

				<BetBuilderPicksPopupFooter
					store={rootStore.quickPlayStore.betBuilderPicksStore}
					slip={
						rootStore.quickPlayStore.betBuilderPicksStore
							.selectedBetSlip
					}
					slipNumber={
						rootStore.quickPlayStore.betBuilderPicksStore.slipIndex
					}
				/>
			</div>
		</div>
	);
});
